<div class="lnot-modal-fundo" #fundo (click)="aoFechar()"></div>

<div class="lnot-modal" [class.lnot-modal-mobile]="mobile()" #caixa role="dialog" aria-modal="true" aria-labelledby="lnot-modal-titulo">
  <header class="lnot-modal-cabecalho">
    <span class="lnot-sino">
      <img src="./assets/icones/redesign/modulos/lembretes/icon-signal-lembrete.svg" alt="" />
    </span>
    <h2 id="lnot-modal-titulo" class="lnot-modal-titulo">Lembrete</h2>
    <button type="button" class="lnot-fechar" aria-label="Fechar" (click)="aoFechar()">
      <img src="./assets/icones/redesign/utils/close-gray.svg" alt="" />
    </button>
  </header>

  <div class="lnot-modal-corpo">
    <div class="lnot-modal-contato">
      <img class="lnot-avatar lnot-modal-avatar" [src]="fotoContato()" alt="" (error)="marcarFotoIndisponivel()" />
      <div class="lnot-modal-contato-textos">
        <span class="lnot-modal-contato-nome">{{ notificacao().contatoNome }}</span>
        @if (notificacao().contatoNumero) {
          <span class="lnot-modal-contato-numero">{{ notificacao().contatoNumero | celularMask }}</span>
        }
      </div>
      @if (notificacao().contatoNumero) {
        <button type="button" class="lnot-modal-ir-contato" aria-label="Abrir conversa do contato" title="Abrir conversa" (click)="aoAbrirContato()">
          <img src="./assets/icones/redesign/modulos/chat/components-message/go-to-chat-primary.svg" alt="" />
        </button>
      }
    </div>

    <div class="lnot-modal-detalhe">
      <span class="lnot-modal-detalhe-titulo">{{ notificacao().titulo }}</span>
      @if (notificacao().anotacao) {
        <span class="lnot-modal-detalhe-anotacao lnot-texto-duas-linhas">{{ notificacao().anotacao }}</span>
      }
      <div class="lnot-modal-detalhe-data">
        <span class="lnot-modal-icone-relogio" aria-hidden="true"></span>
        <span class="lnot-modal-detalhe-data-texto">{{ dataHora() | date: 'dd/MM/yyyy · HH:mm' }}</span>
        @if (rotuloDia(); as rotulo) {
          <span class="lnot-modal-chip-dia">{{ rotulo }}</span>
        }
      </div>
    </div>

    @if (acionavel()) {
      <div class="lnot-modal-adiar">
        <span class="lnot-modal-adiar-rotulo">
          <img class="lnot-icone" src="./assets/icones/redesign/utils/clock-gray.svg" alt="" />
          Adiar (soneca)
        </span>
        <div class="lnot-modal-adiar-opcoes">
          @for (minutos of opcoesAdiamento; track minutos) {
            <button type="button" class="lnot-botao lnot-modal-opcao" (click)="aoAdiar(minutos)">{{ rotuloOpcao(minutos) }}</button>
          }
        </div>
      </div>
    }
  </div>

  <footer class="lnot-modal-rodape">
    <button type="button" class="lnot-botao lnot-modal-botao-dispensar" (click)="aoDispensar()">{{ acionavel() ? 'Agora não' : 'Fechar' }}</button>
    @if (acionavel()) {
      <button type="button" class="lnot-botao lnot-botao-sucesso" (click)="aoConcluir()">
        <img class="lnot-icone" src="./assets/icones/redesign/utils/check-white.svg" alt="" />
        Concluir lembrete
      </button>
    }
  </footer>
</div>
